import React  from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from './Components/Navbar'

function App() {
  return (
    <>
        <Navbar />
    </>
  );
}

export default App;
